export default "__VITE_ASSET__as5LssIm__"